import { Typography } from "@timeedit/ui-components";
import { UtilContext } from "../RegistrationContexts";
import { useContext } from "react";
import {
  RegistrationActivity,
  FrontendRegistrationCourse,
} from "@timeedit/registration-schemas";
import { TitleProps } from "@timeedit/ui-components/antd/typography/Title";

interface GroupPageTitleProps {
  level?: TitleProps["level"];
  semanticLevel?: TitleProps["level"];
  course?: FrontendRegistrationCourse;
  activity?: RegistrationActivity;
  id?: string;
  className?: string;
}
export function GroupPageTitle({
  id,
  level = 3,
  semanticLevel,
  className,
  course,
  activity,
}: GroupPageTitleProps): React.ReactNode {
  const { mapping } = useContext(UtilContext);
  const courseTitle = mapping.parse("courseTitle", course?.teObject);
  const courseLabel = mapping.parse("courseLabel", course?.teObject);

  return (
    <div>
      <Typography.Title
        id={id}
        className={className}
        level={level}
        semanticLevel={semanticLevel}
        style={{ margin: 0 }}
      >
        {activity?.label ?? ""}
      </Typography.Title>
      <div>
        <Typography.Text>
          {courseTitle} - {courseLabel}
        </Typography.Text>
      </div>
    </div>
  );
}
